import WORK_DIALOG_SIZES from '@/components/base_components/dialog/components/enums/WORK_DIALOG_SIZES';

const DIALOG_DEFAULT_HEIGHTS = Object.freeze({
  LARGE_AND_UP: {
    [WORK_DIALOG_SIZES.EXTRA_SMALL]: 30,
    [WORK_DIALOG_SIZES.SMALL]: 40,
    [WORK_DIALOG_SIZES.MEDIUM]: 50,
    [WORK_DIALOG_SIZES.LARGE]: 60,
    [WORK_DIALOG_SIZES.EXTRA_LARGE]: 85,
    [WORK_DIALOG_SIZES.FULL_SIZE]: 100,
  },
  MEDIUM: {
    [WORK_DIALOG_SIZES.EXTRA_SMALL]: 35,
    [WORK_DIALOG_SIZES.SMALL]: 45,
    [WORK_DIALOG_SIZES.MEDIUM]: 55,
    [WORK_DIALOG_SIZES.LARGE]: 65,
    [WORK_DIALOG_SIZES.EXTRA_LARGE]: 85,
    [WORK_DIALOG_SIZES.FULL_SIZE]: 100,
  },
  SMALL: {
    [WORK_DIALOG_SIZES.EXTRA_SMALL]: 40,
    [WORK_DIALOG_SIZES.SMALL]: 50,
    [WORK_DIALOG_SIZES.MEDIUM]: 60,
    [WORK_DIALOG_SIZES.LARGE]: 70,
    [WORK_DIALOG_SIZES.EXTRA_LARGE]: 85,
    [WORK_DIALOG_SIZES.FULL_SIZE]: 100,
  },
  EXTRA_SMALL: 100
});

export default DIALOG_DEFAULT_HEIGHTS;
